module.exports = __webpack_public_path__ + "static/media/dragIcon.05ccb5fc.svg";